import {Divider, Typography} from '@mui/material';
import {StyledTextField} from '@resurs-internal/mui';
import {useTranslate} from 'hooks';
import {DepositUpcomingDateCard} from './DepositUpcomingDateCard';
import {
  clampToSelectableDay,
  MAX_SELECTABLE_DAY,
} from './hooks/useMonthlyDepositForm';

type MonthlyDepositScheduleFieldsProps = {
  day: number;
  repeatDay: string;
  upcomingDate: string;
  onDayChange: (day: number) => void;
};

export const MonthlyDepositScheduleFields = ({
  day,
  repeatDay,
  upcomingDate,
  onDayChange,
}: MonthlyDepositScheduleFieldsProps) => {
  const translate = useTranslate();

  return (
    <>
      <Typography variant={'body1'} sx={{fontWeight: 700}}>
        {translate('savings.deposit.monthly.date')}
      </Typography>
      <StyledTextField
        fullWidth
        type={'number'}
        label={translate('savings.deposit.monthly.day-of-month')}
        value={day.toString()}
        onChange={(event) =>
          onDayChange(clampToSelectableDay(Number(event.target.value)))
        }
        slotProps={{
          htmlInput: {
            min: 1,
            max: MAX_SELECTABLE_DAY,
            step: 1,
            inputMode: 'numeric',
          },
        }}
      />

      <Divider sx={{borderColor: 'divider'}} />

      <Typography variant={'subtitle2'}>
        {translate('savings.deposit.monthly.repeat', [repeatDay])}
      </Typography>

      <DepositUpcomingDateCard upcomingDate={upcomingDate} />
    </>
  );
};
